var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCursor = function SvgCursor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    d: "M5.029 5.77a.59.59 0 0 1 .74-.741L20.59 9.764c.548.175.546.952-.003 1.124l-7.09 2.223a.59.59 0 0 0-.386.386l-2.223 7.09c-.172.55-.949.551-1.124.003z"
  })));
};
export default SvgCursor;